module.exports = __webpack_public_path__ + "img/qld-logo.5a78e704.png";